<mat-card *ngFor="let summary of booksSummary$ | async" style="margin: 15px;">{{summary.genre}}: {{summary.count}}</mat-card>
